import React from "react";
import { Search, FileText, Map, Headphones } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const icons = [Search, FileText, Map, Headphones];

const Process = () => {
  const { lang } = useLanguage();
  const t = translations[lang].process;

  return (
    <section className="relative bg-navy-950 py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading tag={t.tag} title={t.title} desc={t.desc} light center />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 110}>
                <div className="relative h-full">
                  <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 h-full hover:border-amber-500/40 hover:bg-white/[0.06] transition-all duration-300">
                    <div className="flex items-center justify-between">
                      <div className="w-12 h-12 rounded-xl bg-amber-500 flex items-center justify-center">
                        <Icon className="w-6 h-6 text-navy-950" />
                      </div>
                      <span className="font-display font-extrabold text-3xl text-white/10">
                        0{i + 1}
                      </span>
                    </div>
                    <h3 className="mt-5 font-display font-bold text-lg text-white">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-slate-400 text-sm leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
